module.exports = __webpack_public_path__ + "static/media/id_card_model_number_en@2x.181d2f95.png";